<template>
  <div id="footer">
    <img class="altus-logo" :src="image" />
  </div>
</template>

<script>
export default {
  data() {
    return{
      name: 'Manan Vasa',
      image: require('@/assets/altus-corp.jpeg')
    }
  }
}
</script>

<style scoped>
#footer{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F7F7F7;
  padding: 25px;
}

.altus-logo {
  width: 250px;
  max-width: 100%;
}
</style>
